import { fetchUtils } from '../utils/fetchUtils';

export const register = (data) => fetchUtils.post('/api/auth/register', data);
export const login = (data) => fetchUtils.post('/api/auth/login', data);
export const getUserDetails = () => fetchUtils.get('/api/user');
export const updateUser = (data) => fetchUtils.post('/api/user', data);
export const deleteUser = () => fetchUtils.delete('/api/user');
export const logout = () => fetchUtils.get('/api/user/logout');
